export default "__VITE_ASSET__COmHuFBb__"